import config from '../../config';

export default {
  url: `${config.api.baseURL}/glossary`,
  transformer(data) {
    return data;
  }
};
